import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {initialState, State} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {updateStateApi} from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import { StatesListLoading } from '../components/loading/StatesListLoading'
import { isNotEmpty, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import {Toast, ToastContainer} from 'react-bootstrap'

type Props = {
  isStateLoading: boolean
  state: State
}

const stateEditSchema = Yup.object().shape({
  name: Yup.string().required('State name is required'),
})

const StateEditModalForm: FC<Props> = ({state, isStateLoading}) => {
  const {setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })

  const formik = useFormik({
    initialValues: {
      name: state.name || '',
      status: state.status || 1,
    },
    validationSchema: stateEditSchema,
    onSubmit: async (values, {setSubmitting}) => {
      try {
        const response = await updateStateApi(state.id, values)
        if (response.responseStatus === 200) {
          setSessionMessage({type: 'success', message: response.responseMessage, show: true})
          setTimeout(() => {
            setItemIdForUpdate(undefined)
            refetch()
          }, 1500)
        } else {
          setSessionMessage({type: 'danger', message: response.responseMessage, show: true})
        }
      } catch (error: any) {
        const message = error?.message || error?.responseMessage || 'Something went wrong'
        setSessionMessage({type: 'danger', message, show: true})
      } finally {
        setSubmitting(false)
      }
    }
  })

  useEffect(() => {
    if (sessionMessage.show) {
      setTimeout(() => {
        setSessionMessage({type: '', message: '', show: false})
      }, 3000)
    }
  }, [sessionMessage.show])

  return (
    <>
      <div className='form'>
        <div className='d-flex flex-column mb-7 fv-row'>
          <label className='required fw-bold fs-6 mb-2'>State Name</label>
          <input
            placeholder='State Name'
            type='text'
            name='name'
            className={`form-control form-control-solid mb-3 mb-lg-0 ${
              formik.touched.name && formik.errors.name ? 'is-invalid' : ''
            }`}
            autoComplete='off'
            disabled={formik.isSubmitting}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.name && formik.errors.name && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.name}</div>
            </div>
          )}
        </div>

        <div className='text-center pt-15'>
          <button
            type='button'
            onClick={() => setItemIdForUpdate(undefined)}
            className='btn btn-light me-3'
            disabled={formik.isSubmitting}
          >
            Cancel
          </button>
          <button
            type='button'
            onClick={() => formik.handleSubmit()}
            className='btn btn-primary'
            disabled={formik.isSubmitting}
          >
            <span className='indicator-label'>Submit</span>
            {formik.isSubmitting && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
      {(formik.isSubmitting || isStateLoading) && <StatesListLoading />}
      <ToastContainer className='p-3 position-fixed' position={'top-center'}>
        <Toast show={sessionMessage.show} bg={sessionMessage.type}>
          <Toast.Body className='text-white'>{sessionMessage.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  )
}

export {StateEditModalForm}
